const NAME = "ACCUMULATOR_SETTINGS";

export default NAME;
